import { mount } from 'svelte';
import './app.css';
import Router from './Router.svelte';
import { initializeI18n, detectBrowserLocale } from './lib/i18n';
import {
  registerPreloadErrorHandler,
  clearChunkReloadMarker,
  updateFailedText,
} from './lib/chunkReload';
import { LOCALE_CACHE_KEY } from './lib/stores/settingsStore';

/**
 * Initialize the application
 * 1. Read cached locale from localStorage (instant, survives page reload)
 * 2. Fall back to browser detection if no cache exists
 * 3. Initialize i18n and mount the Router
 */
async function bootstrap() {
  // Use cached locale (set by settingsStore on successful load) or fall back to browser detection
  const initialLocale = localStorage.getItem(LOCALE_CACHE_KEY) || detectBrowserLocale();

  // Initialize i18n before rendering
  await initializeI18n(initialLocale);
  // Start succeeded: the next deploy may reload once again (Spec 161 E4)
  // ponytail: one marker per session start — a chunk missing for good after boot (broken deploy) reloads in a loop;
  // add a timestamp window to the marker if that ever happens outside a broken deploy (Spec 161 E4).
  clearChunkReloadMarker();

  // Mount the app
  const app = mount(Router, {
    target: document.getElementById('app')!,
  });

  return app;
}

registerPreloadErrorHandler();

bootstrap().catch((error) => {
  console.error('Failed to bootstrap application:', error);
  // Without a locale every $_() throws, so mounting would leave a white page (Spec 161 E5)
  document.getElementById('app')!.textContent = updateFailedText();
});
